import { render, staticRenderFns } from "./detalhesFaturaAvulsa.vue?vue&type=template&id=33755d2d&scoped=true&"
import script from "./detalhesFaturaAvulsa.vue?vue&type=script&lang=js&"
export * from "./detalhesFaturaAvulsa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33755d2d",
  null
  
)

export default component.exports